module.exports = "/_next/static/images/lc-3995dda774e2c2765b997f477c1d040f.svg";